<template>
  <div class="flex w-16 flex-col items-center font-bold">
    <div
      class="mb-2"
      :class="[value > 100 ? 'text-red' : 'text-green', labelClass || '']"
    >{{ label }}</div>
    <div class="h-2 w-full rounded-sm bg-input">
      <div
        class="h-full rounded-sm"
        :class="value > 100 ? 'bg-red' : 'bg-green'"
        :style="{ width: `${value > 100 ? 100 : value}%` }"
      ></div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: false,
  },
  labelClass: {
    type: String,
    required: false,
  },
  value: {
    type: Number,
    required: true,
  },
});
</script>
